import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { GestionAsistencialCreationContent } from './components/GestionAsistencialCreationContent';

export default function GestionAsistencialCreation() {

    return (
        <MainContent
            component={<GestionAsistencialCreationContent />}
            titulo={`Gestión asistencial`}
            noBackground
            tableMaxWidth
            mainContentWhite
        />
    );

};
